import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var Money2 = function Money2(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6L19 6C19.5523 6 20 5.55229 20 5C20 4.44772 19.5523 4 19 4H5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7051 14.7049C18.5201 14.8949 18.265 14.9999 18 14.9999C17.735 14.9999 17.48 14.8949 17.295 14.7049C17.105 14.5199 17 14.2649 17 14C17 13.735 17.105 13.48 17.295 13.295C17.48 13.105 17.735 13 18 13C18.265 13 18.5201 13.105 18.7051 13.295C18.8951 13.48 19.0001 13.735 19.0001 14C19.0001 14.2649 18.8951 14.5199 18.7051 14.7049Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 14.9999C6.26501 14.9999 6.52003 14.8949 6.70503 14.7049C6.89503 14.5199 7.00002 14.2649 7.00002 14C7.00002 13.735 6.89503 13.48 6.70503 13.295C6.52003 13.105 6.26501 13 6.00001 13C5.73501 13 5.47999 13.105 5.29499 13.295C5.10499 13.48 5.00001 13.735 5.00001 14C5.00001 14.2649 5.10499 14.5199 5.29499 14.7049C5.47999 14.8949 5.73501 14.9999 6.00001 14.9999Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.99999C2 8.89499 2.895 8 4 8H20C21.105 8 22 8.89499 22 9.99999V17.9999C22 19.1049 21.105 19.9999 20 19.9999H4C2.895 19.9999 2 19.1049 2 17.9999V9.99999ZM20 17.9999H15.0078C15.1605 17.7394 15.2959 17.4615 15.415 17.1699C15.79 16.2399 16 15.1549 16 14C15.9951 12.4784 15.6459 11.0877 15.0096 9.99999H20V17.9999ZM4 17.9999H8.99047C8.35421 16.9122 8.00494 15.5215 8.00002 14C8.00002 12.845 8.21004 11.76 8.58504 10.83C8.7042 10.5384 8.83958 10.2605 8.99226 9.99999H4V17.9999ZM12.5901 17.7899C12.3701 17.9449 12.185 17.9999 12 17.9999C11.815 17.9999 11.63 17.9449 11.41 17.7899C11.08 17.5649 10.705 17.0849 10.44 16.4199C10.17 15.7549 10 14.915 10 14C9.99502 12.78 10.305 11.69 10.735 10.98C10.95 10.62 11.19 10.365 11.41 10.21C11.63 10.055 11.815 9.99999 12 9.99999C12.185 9.99999 12.3701 10.055 12.5901 10.21C12.9201 10.435 13.295 10.915 13.56 11.58C13.83 12.245 14 13.085 14 14C14.005 15.2199 13.6951 16.31 13.265 17.02C13.05 17.38 12.8101 17.6349 12.5901 17.7899Z",
    fill: color
  }));
};

export { Money2 };
